import React from 'react'
import RadioButton from './radio-button.component'
import { StyledFlexContainer } from './styled-components'

const style = { width: '100%' }

const PaymentConditions = ({
	user,
	onSelect,
	setIsModalOpen,
	isForSubscribers,
	paymentConditions,
	selectedCondition,
}) => {
	const conditions = paymentConditions
		.map((item, index) => ((item.index = index), item))
		.filter(({ forSubscribers }) => forSubscribers == isForSubscribers)
		.sort((a, b) => a.order - b.order)

	const loggedUserIsNotMember = isForSubscribers && user && !user.plan

	return (
		<StyledFlexContainer
			smRow
			smWrap
			style={style}
			smSpaceAround
			marginTop={0.1}
			alignItems="stretch">
			{renderConditions(
				onSelect,
				conditions,
				setIsModalOpen,
				selectedCondition,
				loggedUserIsNotMember
			)}
		</StyledFlexContainer>
	)
}

function renderConditions(
	onSelect,
	conditions,
	setIsModalOpen,
	selectedCondition,
	loggedUserIsNotMember
) {
	return conditions.map(({ price, points, index }) => {
		const priceText = `${price.$toReais()}`
		const pointsText = `${points.toLocaleString('pt-BR')} pontos`
		let text = `${pointsText}${price > 0 ? ` + ${priceText}` : ''}`

		if (points === 0 && price > 0) {
			text = `${priceText}`
		}
		if (price === 0 && points > 0) {
			text = `${points.toLocaleString('pt-BR')} pontos`
		}

		return (
			<RadioButton
				key={index}
				className="col-3 sm-4 br-5"
				isActive={selectedCondition === index}
				onClick={() =>
					loggedUserIsNotMember ? setIsModalOpen(true) : onSelect(index)
				}>
				<span>{text}</span>
			</RadioButton>
		)
	})
}

export default PaymentConditions
